module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_7042.2e6a13e9.png";